import HeaderItem, { HeaderItemProps } from './HeaderItem';

export type { HeaderItemProps };
export default HeaderItem;
